// extracted by mini-css-extract-plugin
export default {"commentsBtn":"TasksList_commentsBtn__MEgVy"};